export default __webpack_public_path__ + "static/media/app-store-white.56bfe837.svg";